(function (angular) {
  angular.module('xplenty-designer').factory('DesignerBaseSourceAndDestinationComponent', [
    '$rootScope',
    'DesignerComponent',
    'DesignerConnection',
    'DesignerSchema',

    function ($rootScope, DesignerComponent, DesignerConnection, DesignerSchema) {
      function DesignerBaseSourceAndDestinationComponent() {
        DesignerComponent.apply(this);

        this.connection = new DesignerConnection();
        this.schema = new DesignerSchema();
      }

      DesignerBaseSourceAndDestinationComponent.prototype = new DesignerComponent();

      DesignerBaseSourceAndDestinationComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          connection: this.connection.getData(),
          schema: this.schema.getData(),
          dynamic_connection: this.dynamic_connection,
        });

        return data;
      };

      DesignerBaseSourceAndDestinationComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerBaseSourceAndDestinationComponent.prototype.setData = function (data) {
        this.connection.setData(data.connection);
        this.schema.setData(data.schema);
        this.dynamic_connection = data.dynamic_connection;

        DesignerComponent.prototype.setData.call(this, data);
      };

      return DesignerBaseSourceAndDestinationComponent;
    },
  ]);
})(window.angular);
